import request from '../../util/SuperagentUtils';
import { bookingRequests } from '../../requests/api-endpoints';

const handleResponse = (response) => {
  if (!response.ok) {
    throw Error(`${response.status} - ${response.statusText}`);
  }
  return response.text();
};

export const sendBookingConfirmationEmail = async (bookingId) => {
  const response = await fetch(bookingRequests.sendConfirmationEmail, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json",
    },
    body:  JSON.stringify({bookingId}),
  });
  return handleResponse(response);
};

export const requestDenyRefund = async (bookingTransactionId) => {
  const response = await fetch(bookingRequests.denyRefund, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json",
    },
    body:  JSON.stringify({bookingTransactionId}),
  });
  return handleResponse(response);
};

export const bookSpace = (bookingRequest) => {
  return request.post(bookingRequests.create).send(bookingRequest);
};

export const cancelBooking = (payload) => {
  return request.post(bookingRequests.cancel).send(payload);
};

export const cancelBookingSubscription = (payload) => {
  return request.post(bookingRequests.cancelSubscription).send(payload);
};

export const calculateBookingChargeAmount = (bookingData) => {
  return request.post(bookingRequests.calculateBookingChargeAmount).send(bookingData);
};

export const completeBooking = async (bookingData) => {
  const payload = {
    bookingId: bookingData?.bookingId,
    tosDocUrl: bookingData?.tosDocUrl
  };
  return request.post(bookingRequests.completeBooking).send(payload);
};

export const getBookingInfo = async (bookingId) => {
  return request.get(bookingRequests.getBookingById(bookingId));
};

export const adjustEndDate = (adjustDateRequest) => {
  return request.post(bookingRequests.adjustDates).send(adjustDateRequest);
};

export const adjustEndDateRecurring = (adjustDateRequest) => {
  return request.post(bookingRequests.adjustEndDate).send(adjustDateRequest);
};

export const adjustNumberOfSpaces = (adjustNumberOfSpacesRequest) => {
  return request.post(bookingRequests.adjustNumberOfSpaces).send(adjustNumberOfSpacesRequest);
};

export const updatePaymentMethodForBooking = (updatePaymentData) => {
  return request.post(bookingRequests.updateBookingPaymentMethod).send(updatePaymentData)
};

export const getBookingByToken = (token) => {
  return request.get(bookingRequests.bookingByToken(token));
};

export const approveOrDeclineByToken = (token, payload) => {
  return request.post(bookingRequests.bookingByToken(token)).send(payload)
}
